import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import store from '../../states';
import Button from '../widgets/button';
import { sspRemoveDemandFromDealAPI } from '../../services/tags';

export default ({ id, selectedDeal, onHide, show, api }: any) => {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [glossary, sGlossary] = useState<any>({});
  useEffect(() => {
    sGlossary(store.getState());
    const unsubscribe = store.subscribe(() => {
      sGlossary(store.getState());
    });
    return () => unsubscribe();
  }, []);

  const handleDelete = (api: any) => {
    const payload = {
      deal_id: selectedDeal,
      endpoints: [id],
    };
    setBtnDisabled(true);
    sspRemoveDemandFromDealAPI(payload)
      .then((data: any) => {
        if (data) {
          onHide();
          api(selectedDeal);
          setBtnDisabled(false);
          toast.success(glossary.admin_deal_delete_popup_succss_message);
        } else {
          toast.error(data.message);
          setBtnDisabled(false);
        }
      })
      .catch(() => {
        //
      });
  };

  return (
    <Modal onHide={onHide} show={show} centered size={'lg'}>
      <Modal.Header>
        <h2>{glossary.ssp_assigned_customer_delete_popup_title}</h2>
      </Modal.Header>
      <Modal.Body style={{ padding: '40px' }}>
        {glossary.ssp_assigned_customer_delete_popup_body}
      </Modal.Body>
      <Modal.Footer className='gap-2'>
        <Button
          kind={'secondary'}
          text={glossary.admin_deal_delete_popup_button_cancel}
          click={() => onHide()}
        />
        <Button
          kind={btnDisabled ? 'disabled' : 'primary'}
          text={glossary.admin_deal_delete_popup_button_delete}
          click={() => handleDelete(api)}
        />
      </Modal.Footer>
    </Modal>
  );
};
